
import styled from 'styled-components'
import { lightThemeColors } from '../../assets/style/colors';
import { flip, offset, safePolygon, shift, useFloating, useHover, useInteractions } from '@floating-ui/react';
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const MenuButton = ({ title, menuOptions, buttonLink, setIsBackgropVisible, navigateTo }) => {
    const [isOpen, setIsOpen] = useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        placement: "bottom-start",
        transform: true,
        onOpenChange: (e) => { handleOpenChange(e) },
        middleware: [offset(10), shift()],
    });

    const hover = useHover(context, {
        handleClose: safePolygon(), // ensures it doesn't close when moving between button and menu
    });

    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
    ]);

    const handleOpenChange = (e) => {
        if (!menuOptions) {
            return
        }
        setIsOpen(e)
        setIsBackgropVisible(e)
    }

    const handleOptionClick = (item, e) => {
        handleOpenChange(e)
        navigateTo(item.link, item.linkType)
    }

    return (
        <Container>
            <HeaderBtn ref={refs.setReference} {...getReferenceProps()} isOpen={isOpen} onClick={() => buttonLink && handleOptionClick(buttonLink, false)} className='headerBtnId'>
                {title}
                <BottomDecoration />
            </HeaderBtn>
            {isOpen && menuOptions && (
                <AnimatePresence >
                    <>
                        <MenuContent
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.4 }}

                            ref={refs.setFloating}
                            style={floatingStyles}
                            {...getFloatingProps()}
                        >
                            {menuOptions?.map((option, index) => (
                                <Category key={index}>
                                    {option.categoryTitle && <h2>{option.categoryTitle}</h2>}
                                    {option.categoryItems.map((item, inedx) => (

                                        <MenuOption key={item.title} onClick={() => handleOptionClick(item, false)}>
                                            <h3>{item.title}</h3>
                                            <p>{item.description}</p>
                                        </MenuOption>

                                    ))}
                                </Category>
                            ))}

                        </MenuContent>
                    </>
                </AnimatePresence>
            )}

        </Container>
    )
}

export default MenuButton
const Container = styled.div`
display:flex;
position:relative;
`
const BottomDecoration = styled.div`
display:flex;
max-width:34px;
width:100%;
position:absolute;
bottom:-2px;
min-height:2px;
border-radius:2px;
background:${lightThemeColors.header.menuItemColor};
  opacity: 0;
`
const HeaderBtn = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ isOpen }) => isOpen ? lightThemeColors.header.menuItemColor : lightThemeColors.header.menuItemColorFaded};
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  text-align: left;
  padding:0 0 2px 0;
  margin-bottom:-2px;
  position:relative;
  width:100%;
  justify-content:center;
${({ isOpen }) => isOpen &&
        `
div {   
    opacity: 1;
  }
    `
    }
    &:hover{
    color:${lightThemeColors.header.menuItemColor};
    }
  &:hover > div {   
    opacity: 1;
  }
`;
const MenuContent = styled(motion.div)`
  display:flex;
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  padding:10px 0;
  border-radius:10px;
  z-index: 100;
  gap:0px;
`



const MenuOption = styled.div`
display:flex;
flex-direction:column;
gap:8px;
width:250px;
padding:10px 25px;

&:hover{
background:${lightThemeColors.darkColorFullFaded};
}
cursor:pointer;
h3{
color:${lightThemeColors.darkColor};
font-weight: 500;
font-size: 14px;
line-height: 16px;
}
p{
color:${lightThemeColors.darkColorFaded};
font-weight: 400;
font-size: 10px;
line-height: 12px;
}
`
const Category = styled.div`
display:flex;
flex-direction:column;
max-width:300px;
width:100%;
h2{
padding:10px 25px;
color:${lightThemeColors.header.categoryTypeColor};
font-weight: 900;
font-size: 10px;
line-height: 12px;

}
`
